import { FC } from 'react';
import { Flex, Text, Icon } from '@/_components';
import type { SelectedEntityProps } from './SelectedEntity.types';

export const SelectedEntity: FC<SelectedEntityProps> = ({ name }) => {
  return (
    <Flex gap={2} isYCentered={true}>
      <Text type="small" color="secondary">
        Selected Entity:
      </Text>
      <Flex isYCentered={true} gap={2}>
        <Icon name="users" size={16} />
        <Text type="small" fontWeight="medium">
          {name}
        </Text>
      </Flex>
    </Flex>
  );
};
